// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BOz-_","left":"styles_left__2cDn5"};